import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { color } from 'styled-system';
import { Flex } from '../containers/Flex/Flex.component';
import { Text } from '../typography';
import { IIconProps, Icon } from '../icons/Icon.component';
import { Color, colors } from '../themes';
import { Group } from '../containers/Group/Group.component';

export const sizes = {
  s: { itemGap: 3, contentGap: 2, contentDiameter: 24, textSize: 14 },
  l: { itemGap: 6, contentGap: 4, contentDiameter: 34, textSize: 16 },
};

const Content = styled(({ size, icon, text, ...props }) => (
  <Flex {...props}>
    {icon && <Icon icon={icon} color={'gray.0'} size={size === 'l' ? 18 : 14} />}
    {text && (
      <Text color={'gray.0'} weight={500} size={sizes[size].textSize}>
        {text}
      </Text>
    )}
  </Flex>
))<{ background: string }>`
  position: relative;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: ${({ size }) => sizes[size].contentDiameter}px;
  height: ${({ size }) => sizes[size].contentDiameter}px;
  ${color}
`;

export const Timeline = styled(Group)`
  padding: 2em 0;
  position: relative;

  &:not(:last-child):before {
    content: '';
    position: absolute;
    top: 2em;
    left: 16px;
    height: 100%;
    width: 2px;
    background: ${colors.gray[500]};
  }
`;

interface ITimelineItemProps {
  size?: 's' | 'l';
  icon?: IIconProps['icon'];
  text?: string;
  backgroundColor: Color | string;
  subject?: string;
  children: React.ReactNode;
  innerRef?: React.Ref<HTMLDivElement>;
}

export const TimelineItem: FunctionComponent<ITimelineItemProps> = ({
  size = 'l',
  icon,
  backgroundColor,
  text,
  children,
  subject,
  innerRef,
}) => {
  return (
    <Timeline ref={innerRef} gap={sizes[size].contentGap} context={'timeline-item'} subject={subject} width={'100%'}>
      <Content size={size} icon={icon} text={text} backgroundColor={backgroundColor} />
      {children}
    </Timeline>
  );
};
